import {postRequest} from '../../../../../middlewares/api/actions';
import { getEditCsvFieldUrl } from '../../../../../constants/urls';

export const FILE_MAPPING_WIZARD_CSV_HEADER_FORM_SHOW = 'FILE_MAPPING_WIZARD_CSV_HEADER_FORM_SHOW';
export const FILE_MAPPING_WIZARD_CSV_HEADER_FORM_HIDE = 'FILE_MAPPING_WIZARD_CSV_HEADER_FORM_HIDE';
export const FILE_MAPPING_WIZARD_CSV_HEADER_FORM_CHANGE = 'FILE_MAPPING_WIZARD_CSV_HEADER_FORM_CHANGE';
export const FILE_MAPPING_WIZARD_CSV_HEADER_FORM_SUBMIT = 'FILE_MAPPING_WIZARD_CSV_HEADER_FORM_SUBMIT';

export const showFileMappingWizardCsvHeaderFormModal = component => ({
  type: FILE_MAPPING_WIZARD_CSV_HEADER_FORM_SHOW,
  listComponent : component
})

export const hideFileMappingWizardCsvHeaderFormModal = () => ({
  type: FILE_MAPPING_WIZARD_CSV_HEADER_FORM_HIDE
})

export const onCsvHeaderFormDataChange = field => ({
  type: FILE_MAPPING_WIZARD_CSV_HEADER_FORM_CHANGE,
  fields: field
})

export const submitFileMappingWizardCsvHeaderForm = (tableName, fieldname, newFieldName) => postRequest(
  FILE_MAPPING_WIZARD_CSV_HEADER_FORM_SUBMIT,
  getEditCsvFieldUrl(tableName, fieldname, newFieldName)
) 